// Shared MIME helpers for the bulk-import sources (Drive, local folder,
// Dropbox, iCloud). Sources that only provide filenames (Dropbox, iCloud)
// derive the MIME from the extension.

export const IMPORTABLE_MIMES = new Set<string>([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/heic',
  'image/heif',
  'video/mp4',
  'video/quicktime',
  'video/x-m4v',
  'audio/mpeg',
  'audio/mp4',
  'audio/x-m4a',
  'audio/wav',
  'audio/x-wav',
  'application/pdf',
]);

export const isImportableMime = (mime: string) =>
  IMPORTABLE_MIMES.has(mime) && !mime.startsWith('application/vnd.google-apps');

export const EXT_MIME: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  m4v: 'video/x-m4v',
  mp3: 'audio/mpeg',
  m4a: 'audio/mp4',
  wav: 'audio/wav',
  pdf: 'application/pdf',
};

export const mimeFromFileName = (name: string): string => {
  const ext = name.toLowerCase().split('.').pop() || '';
  return EXT_MIME[ext] || 'application/octet-stream';
};

export const guessMime = (file: File): string => {
  if (file.type && IMPORTABLE_MIMES.has(file.type)) return file.type;
  const ext = file.name.toLowerCase().split('.').pop() || '';
  return EXT_MIME[ext] || file.type || 'application/octet-stream';
};
